import { IBuscaOpcaoPagamentoRequest } from './types';
import api from "../api";
import { IBuscaOpcaoPagamento } from 'interfaces/BuscaOpcaoPagamento';

export const buscaOpcaoPagamentoService = async (data: IBuscaOpcaoPagamentoRequest) => await api.post<IBuscaOpcaoPagamento>('busca-opcao-pagamento', data);